import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = {};

export function useFetch(path, fallback = null) {
    const [data, setData] = useState(cache[path] ?? fallback);
    const [loading, setLoading] = useState(!(path in cache));
    useEffect(() => {
        let alive = true;
        api.get(path).then(({ data }) => { if (alive) { cache[path] = data; setData(data); } })
            .catch(() => {}).finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [path]);
    return { data, loading };
}

export const clearCache = (path) => { delete cache[path]; };
